/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* A single log record from the text index.
*/
export class LogRecord {
  /**
  * Unique identifier for the log record.
  */
  'rowId': string;
  /**
  * The raw log content.
  */
  'raw': string;
  /**
  * The timestamp of the log record.
  */
  'timestamp': string;
  /**
  * The level of the log record.
  */
  'level': string;
  /**
  * Parsed fields from the log record.
  */
  'fields': { [key: string]: string; };
  /**
  * The partition date of the log record.
  */
  'partitionDate': string;
  /**
  * The batch ID of the log record.
  */
  'batchId'?: string;
  /**
  * Positions of matches in the log record.
  */
  'matchPositions'?: Array<number>;
  /**
  * The resource ID this log belongs to.
  */
  'resourceId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "rowId",
      "baseName": "rowId",
      "type": "string",
      "format": ""
    },
    {
      "name": "raw",
      "baseName": "raw",
      "type": "string",
      "format": ""
    },
    {
      "name": "timestamp",
      "baseName": "timestamp",
      "type": "string",
      "format": ""
    },
    {
      "name": "level",
      "baseName": "level",
      "type": "string",
      "format": ""
    },
    {
      "name": "fields",
      "baseName": "fields",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "partitionDate",
      "baseName": "partitionDate",
      "type": "string",
      "format": ""
    },
    {
      "name": "batchId",
      "baseName": "batchId",
      "type": "string",
      "format": ""
    },
    {
      "name": "matchPositions",
      "baseName": "matchPositions",
      "type": "Array<number>",
      "format": ""
    },
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LogRecord.attributeTypeMap;
  }

  public constructor() {
  }
}

